export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-black to-emerald-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/1b5bf65cdb1167a86a15b5f9c79eaa66/706f2801b9b9f5e313c7f2344dd0bcdb.jpeg" 
              alt="GO BACK LOGISTIQUE" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-300 mb-6 leading-relaxed">
              Votre partenaire de confiance pour le transport et la livraison de fleurs depuis Gentilly.
            </p>
            <div className="flex gap-4">
              <a 
                href="https://www.instagram.com/gobacklogistique?igsh=MXZhcGU2MnlkcGx5aA==" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-emerald-600 rounded-full transition-colors cursor-pointer"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-bold text-white mb-4">Navigation</h4>
            <ul className="space-y-2">
              <li>
                <a href="/#services" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Services
                </a>
              </li>
              <li>
                <a href="/#about" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  À Propos
                </a>
              </li>
              <li>
                <a href="/#contact" className="text-gray-300 hover:text-white transition-colors cursor-pointer">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Services</h4>
            <ul className="space-y-3 text-gray-300">
              <li>Transport Express</li>
              <li>Service Fleuristes</li>
              <li>Grossistes & Professionnels</li>
              <li>Gestion de Stock</li>
              <li>Livraisons Planifiées</li>
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-bold mb-4">Contact</h4>
            <ul className="space-y-3 text-gray-300">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-emerald-400 mt-1"></i>
                <span>102 Avenue des Maraichers<br />Batiment C1<br />94550 Chevilly-Larue<br />France</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-emerald-400"></i>
                <span>06 06 70 26 20</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-emerald-400"></i>
                <span>gobacklogistique@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-300 text-sm">
              © 2024 GO BACK LOGISTIQUE. Tous droits réservés.
            </p>
            <div className="flex gap-6 text-sm">
              <a href="#" className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">
                Mentions légales
              </a>
              <a href="#" className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">
                Politique de confidentialité
              </a>
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-300 hover:text-emerald-400 transition-colors cursor-pointer">
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}